var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-content"},[_c('iframe',{attrs:{"id":"iFrame","src":_vm.url,"allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }